const WEEK_DAY = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];

const timeTool = {
    /**
     * 将星期数组[0, 1, 2, 3, 4, 5, 6]格式化为星期文字
     * 注意: 连续3天会转化为周X至周X
     * @param {Array} weekday
     */
    formatWeekday(weekday) {
        let i = 0;
        const len = weekday.length;
        let moveArr = [i];

        const retArr = [];

        // 调整周日值为7，方便计算
        const weekdayTmp = weekday.map(day => (day === 0 ? 7 : day)).sort();

        while (i < len) {
            if (i === len - 1 || weekdayTmp[i + 1] - weekdayTmp[i] > 1) {
                if (moveArr.length < 3) {
                    moveArr.forEach(idx => {
                        retArr.push(WEEK_DAY[weekdayTmp[idx] - 1]);
                    });
                } else {
                    retArr.push(
                        `${WEEK_DAY[weekdayTmp[moveArr[0]] - 1]}至${
                            WEEK_DAY[weekdayTmp[moveArr[moveArr.length - 1]] - 1]
                        }`
                    );
                }
                // eslint-disable-next-line no-plusplus
                moveArr = [++i];
            } else {
                // eslint-disable-next-line no-plusplus
                moveArr.push(++i);
            }
        }

        return retArr.join('，');
    },

    /**
     * 00:00:00-00:00:00格式化为00:00-00:00
     * @param {String} time
     */
    formatTime(time) {
        return time
            .split('-')
            .map(item => {
                const timeRange = item.split(':');
                return `${timeRange[0]}:${timeRange[1]}`;
            })
            .join('-');
    },

    /**
     * 1997-01-01 00:00:00格式化为1997-01-01 00:00
     * @param {String} time
     */
    formatDate(date) {
        const dateRange = date.split(' ');
        const timeRange = dateRange[1].split(':');
        return `${dateRange[0]} ${timeRange[0]}:${timeRange[1]}`;
    }
};

export default timeTool;
